/**
 * Convert a raw GHL time string (e.g. "14:30" or "2026-05-29T14:30:00+00:00")
 * to a human-readable format like "2:30 PM".
 */
export function formatTime(raw) {
  if (!raw) return raw;

  // If it's a full ISO timestamp, parse just the time part
  if (raw.includes("T")) {
    const d = new Date(raw);
    return d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
  }

  // Plain HH:MM string
  const [hStr, mStr] = raw.split(":");
  const h = parseInt(hStr, 10);
  const m = parseInt(mStr || "0", 10);
  const period = h >= 12 ? "PM" : "AM";
  const hour = h % 12 === 0 ? 12 : h % 12;
  const minute = m.toString().padStart(2, "0");
  return `${hour}:${minute} ${period}`;
}

const GHL_API_KEY = process.env.REACT_APP_GHL_API_KEY;
const GHL_CALENDAR_ID = process.env.REACT_APP_GHL_CALENDAR_ID;

/**
 * Fetch available slots from GHL for a date range.
 * Returns: { "2026-05-29": ["09:00", "10:00", ...], ... }
 */
export async function fetchGHLSlots(startDate, endDate, timezone = "America/New_York") {
  const startMs = startDate.getTime();
  const endMs = endDate.getTime();

  const url = new URL(
    `https://services.leadconnectorhq.com/calendars/${GHL_CALENDAR_ID}/free-slots`
  );
  url.searchParams.set("startDate", startMs);
  url.searchParams.set("endDate", endMs);
  url.searchParams.set("timezone", timezone);

  const res = await fetch(url.toString(), {
    headers: {
      Authorization: `Bearer ${GHL_API_KEY}`,
      Version: "2021-04-15",
    },
  });

  if (!res.ok) throw new Error(`GHL API error: ${res.status}`);

  const data = await res.json();

  // GHL response shape: { date: { slots: ["09:00", "10:00"] } }
  // Normalize to: { "2026-05-29": ["09:00", "10:00"] }
  const result = {};
  if (data && typeof data === "object") {
    for (const [dateKey, val] of Object.entries(data)) {
      // Skip non-date keys (e.g. "_dates" meta)
      if (!/^\d{4}-\d{2}-\d{2}$/.test(dateKey)) continue;
      const slots = Array.isArray(val) ? val : (val?.slots ?? []);
      if (slots.length > 0) result[dateKey] = slots;
    }
  }

  return result;
}
